import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { IEditOptions } from '../site-edit.component';
import { ManikEntityFE } from 'src/app/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';

@Component({
  selector: 'app-microsite-about',
  templateUrl: './microsite-about.component.html'
})
export class MicrositeAboutComponent extends ManikEntityFE implements OnInit {
  PageForm: FormGroup;
  SectionForm: FormGroup;
  IsPageLoaded: boolean = false;
  ShowPageSettings: boolean = true;
  ShowSectionList: boolean = false;
  ShowBackgroundSettings: boolean = false;
  public ImageData: any = { MediaID: "", LGContext: "BIZ", ShowItems: "NFICVYS", ShowEditOptions: true, View: 'R' };
  SectionNotSelected: boolean = true;
  @Input() public EditOption: IEditOptions;
  PageData: any = [];
  SectionData: any = [];
  MicroPageID: number;
  populateControls(): void {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null,
      this.prepareEditHeaders2(this.EditOption.BusinessID + "_" + this.EditOption.Type, "MICROPAGE", "BIZ", this.EditOption.PortalContext))
      .subscribe(data => {
        this.IsPageLoaded = true;
        this.PageData = data.ManikJSon[0].JSon0;
        this.SectionData = data.ManikJSon[0].JSon1;
        this.PageForm.patchValue(this.PageData[0]);
        this.MicroPageID = this.SectionData[0].MicroPageID;
     
        // this.cdRef.detectChanges();
      });
  }

  constructor(private formBuilder: FormBuilder,private cdRef: ChangeDetectorRef, private _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.PageForm = this.formBuilder.group({
      ActionText: [''],
      ActionURL: [''],
      BusinessID: [''],
      IsActive: [''],
      MicroPageID: [''],
      PageDescription: [''],
      PageHeaderText: [''],
      PageSloganText: [''],
      ReservedIdentifier: [''],
      SectionTypeID: [''],
      ShowActionButton: ['']
    });
    this.SectionForm = this.formBuilder.group({
      ActionText: [''],
      ActionURL: [''],
      BuyText: [''],
      BuyURL: [''],
      ContentHeader: [''],
      ContentIconText: [''],
      ContentSubHeader: [''],
      ContentText: [''],
      DisplayOrder: [''],
      IsActive: [''],
      MicroPageID: [''],
      PriceTag: [''],
      ShowActionButton: [''],
      ShowBuyButton: [''],
      SmallContentID: [''],
      StyleClass: ['']
    });
  }

  ngOnInit() {
    this.populateControls();
    // this.cdRef.detectChanges(); 
  }

  get GetPageForm() {
    return this.PageForm.controls;
  }

  get GetSectionForm() {
    return this.SectionForm.controls;
  }

  PopulateMenu2(menu: any) {
    switch (menu) {
      case "Page":
        this.ShowPageSettings = true;
        this.ShowSectionList = false;
        this.ShowBackgroundSettings = false;
        this.PageForm.patchValue(this.PageData[0]);
        break;
      case "Section":
        this.ShowPageSettings = false;
        this.ShowSectionList = true;
        this.ShowBackgroundSettings = false;
        break;
      case "Background":
        this.ShowPageSettings = false;
        this.ShowSectionList = false;
        this.ShowBackgroundSettings = true;
        break;
        
    }
    // this.cdRef.detectChanges(); 
  }
  CancelSubmit() {
    this.ShowPageSettings = false;
    this.ShowSectionList = false;
    this.ShowBackgroundSettings = false;
  }

  SubmitPageSettings(event: any) {
    this.PreSubmit(event);
    let body: any = {};
    body = this.PageForm.value;
    let SubmitBody = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmitBody, this.prepareManageHeaders2("SMART_MANAGE", "MICROPAGE", "BIZ", sessionStorage.getItem("PortalIdentifier")))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        if (id != null) {
          this.PostSubmit(event, true);
          this.showNotification('bottom', 'right', 'success', 'Page setting update: Success');
          this.populateControls();
        }
      },
        error => {
          this.PostSubmit(event, true);
          this.showNotification('bottom', 'right', 'danger', 'Page setting update: Failure');
          this.populateControls();
        });

  }

  SubmitSectionSettings(event: any) {
    this.PreSubmit(event);
    let body: any = {};
    body = this.SectionForm.value;
    let SubmitBody = JSON.stringify({ 'items': [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmitBody, this.prepareManageHeaders2("SMART_MANAGE", "MICROPAGE.SMALLCONTENT", "BIZ", sessionStorage.getItem("PortalIdentifier")))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0;
        if (id != null) {
          this.PostSubmit(event, true);
          this.showNotification('bottom', 'right', 'success', 'Paragraph setting update: Success');
          this.populateControls();
        }
      },
        error => {
          this.PostSubmit(event, true);
          this.showNotification('bottom', 'right', 'danger', 'Paragraph setting update: Failure');
          this.populateControls();
        });
  }

  OnSelectSection(item: any) {
    this.SectionNotSelected = false;
    this.SectionForm.patchValue(item);
  }

}
